import Dialog from '@zenbusiness/zui/Dialog';
import DialogContent from '@zenbusiness/zui/DialogContent';
import DialogTitle from '@zenbusiness/zui/DialogTitle';
import IconButton from '@zenbusiness/zui/IconButton';
import SharedAsset from '@zenbusiness/zui/SharedAsset';
import PropTypes from 'prop-types';

export default function CustomizedDialog({ handleClose, children }) {
  return (
    <Dialog
      disableRestoreFocus
      fullScreen
      onClose={handleClose}
      open
    >
      <DialogTitle
        display="flex"
        justifyContent="end"
      >
        <IconButton
          label=""
          onClick={handleClose}
          size="small"
        >
          <SharedAsset
            alt=""
            height={12}
            src="/icon/micro/close-x.svg"
            width={12}
          />
        </IconButton>
      </DialogTitle>
      <DialogContent>{children}</DialogContent>
    </Dialog>
  );
}

CustomizedDialog.propTypes = {
  handleClose: PropTypes.func,
  children: PropTypes.node
};
